<template>
  <v-dialog
    v-model="config.show"
    :persistent="config.persistent"
    max-width="480"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>{{ config.title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="config.show = false">
          <v-icon>{{ mdiClose }}</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>{{ config.text }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <button class="tb_btn2" @click="cancel" v-show="config.cancelShow">
          取消
        </button>
        <button class="tb_btn1" @click="confirm">
          {{ config.confirmText || '确认' }}
        </button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiClose } from '@mdi/js'

export default {
  name: 'Confirm',
  data: () => ({
    config: {},
    mdiClose,
  }),
  methods: {
    init(config) {
      this.config = Object.assign(
        {
          show: true,
          persistent: false,
          title: '提示',
          text: '',
          cancelShow: true,
          cancel: () => {},
          confirm: () => {},
        },
        config
      )
    },
    show() {
      this.config.show = true
    },
    hide() {
      this.config.show = false
    },
    cancel() {
      this.config.cancel()
      this.hide()
    },
    confirm() {
      this.config.confirm()
      this.hide()
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/scss/variables.scss';
.color {
  color: $color;
}
.tb_btn {
  cursor: pointer;
  padding: 8px 18px;
  transition: all 0.3s;
  min-width: 102px;
  margin-left: 18px;
  &:first-child {
    margin-left: 0;
  }
  &.small {
    padding: 3px 12px;
    min-width: 82px;
    font-size: 14px;
    &.tb_btn1:hover {
      background-color: $color;
      border-color: $color;
      color: #fff;
    }
  }
  &:focus {
    outline: none;
  }
}
.tb_btn1 {
  @extend .tb_btn;
  background-color: $color;
  border: 1px solid $color;
  color: #fff;
  &:hover {
    background-color: darken($color, 5%);
    border-color: darken($color, 5%);
  }
}
.tb_btn2 {
  @extend .tb_btn;
  border: 1px solid $color;
  color: $color;
  &:hover {
    border-color: darken($color, 10%);
    color: darken($color, 10%);
  }
}
.tb_btn3 {
  @extend .tb_btn;
  border: 1px solid #d6d6d6;
  color: #666;
  &:hover {
    border-color: darken(#d6d6d6, 10%);
    color: darken(#666, 10%);
  }
}
.v-card__text {
  padding: 20px !important;
}
</style>
